import { normalizePlanId } from '../services/packsApi';

/** Routes entièrement bloquées pour le pack free (aucune pour l’instant — voir/éditer OK, save bloqué ailleurs). */
const PAID_PACK_PREFIXES = [];

const PACK_LABELS = {
  fr: {
    free: 'Gratuit',
    entrepreneur: 'Entrepreneur',
    business: 'Business',
  },
  en: {
    free: 'Free',
    entrepreneur: 'Entrepreneur',
    business: 'Business',
  },
  ar: {
    free: 'مجاني',
    entrepreneur: 'رائد الأعمال',
    business: 'Business',
  },
};

export function getUserPackName(user) {
  return user?.subscription?.pack?.name ?? '';
}

export function getUserPlanId(user) {
  const raw = getUserPackName(user);
  return raw ? normalizePlanId(raw) : 'free';
}

/** true while user.subscription.is_trial is active (pack.end_date not yet passed). */
export function isTrialUser(user) {
  const sub = user?.subscription;
  if (!sub?.is_trial) return false;
  const endDate = sub?.pack?.end_date;
  if (endDate) {
    const end = new Date(endDate).getTime();
    if (!Number.isNaN(end) && end < Date.now()) return false;
  }
  return true;
}

export function getUserTrialEndDate(user) {
  return user?.subscription?.pack?.end_date ?? null;
}

/** Trial users get full paid-plan access — every gate below derives from this. */
export function isFreePackUser(user) {
  if (isTrialUser(user)) return false;
  return getUserPlanId(user) === 'free';
}

export function canAccessMarketing(user) {
  return !isFreePackUser(user);
}

/** Pack free : sauvegarde CMS/thème autorisée (seuls storefront + envoi marketing restent bloqués). */
export function canSaveCms(_user) {
  return true;
}

/** Envoi de campagnes marketing (email + SMS) — réservé aux packs payants et à l'essai. */
export function canSendCampaign(user) {
  return !isFreePackUser(user);
}

/** Pixels / Google Analytics — sauvegarde autorisée pour tous les packs. */
export function canSaveTracking(_user) {
  return true;
}

/** Éditeur de code thème — sauvegarde autorisée pour tous les packs. */
export function canSaveCodeEditor(_user) {
  return true;
}

/**
 * Voir la boutique (storefront) — bloqué en pack free : une fois retombé en free,
 * le déploiement de la boutique est désactivé côté serveur, donc le lien n'ouvre
 * plus rien. On affiche la modale d'upgrade à la place.
 */
export function canDeployStore(user) {
  return !isFreePackUser(user);
}

/**
 * KIOAGENT (bot Messenger / WhatsApp) — accès décidé par kio-api (`kioagent` de
 * `GET /connect/user/` : pack de l'abonnement actif ou forçage admin ; pour un staff,
 * celui du propriétaire). Indépendant de KIOSTORE : un pack free peut y avoir accès.
 */
export function canUseKioAgent(user) {
  return user?.kioagent === true;
}

export function isPackPathBlocked(user, path) {
  if (!path || !isFreePackUser(user)) return false;
  return PAID_PACK_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

export function isPackPathAllowed(user, path) {
  return !isPackPathBlocked(user, path);
}

export function formatPackDisplayName(packName, lang = 'fr') {
  const labels = PACK_LABELS[lang] || PACK_LABELS.fr;
  const planId = normalizePlanId(packName || 'free');
  if (planId === 'free') return labels.free;
  if (planId === 'entrepreneur') return labels.entrepreneur;
  if (planId === 'business') return labels.business;
  return packName || labels.free;
}

export function getUserPackStartDate(user) {
  return user?.subscription?.pack?.start_date ?? null;
}

export function hasActivePosPack(user) {
  return Boolean(user?.subscription?.pos?.status);
}

export function getUserPosPackName(user) {
  return user?.subscription?.pos?.name ?? '';
}
